// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fxv5","questions":"styles_questions__okVt1","footer":"styles_footer__2r1iC"};